export const limiteCaracteres = {
    RELAT_ACOMP_ASSINATURA: 35,
    RELAT_ACOMP_OBS_ITEM: 600, 
    RELAT_ACOMP_RESUMO_FRAG: 2000
}